import {BASE_URL} from 'appConstants';
import {get, post, requestBlob} from 'sdk';

export const fetchArrivals = ({locationRef, option, dateFrom, dateTo}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/front-desk/arrivals/for/${option}/`;
  const params = {dateFrom, dateTo};

  return get(url, params);
};

export const exportArrivalsCsv = ({locationRef, option, dateFrom, dateTo}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/front-desk/arrivals/for/${option}/export-csv/`;
  const params = {dateFrom, dateTo};

  return get(url, params);
};

export const exportArrivalsCsvInBackground = ({
  locationRef,
  option,
  dateFrom,
  dateTo
}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/front-desk/arrivals/for/${option}/export-csv/in-background/`;
  const params = {dateFrom, dateTo};

  return get(url, params);
};

export const fetchCheckedInTodayArrivals = ({locationRef}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/front-desk/arrivals/checked-in-today/`;

  return get(url);
};

export const fetchDepartures = ({locationRef, option, dateFrom, dateTo}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/front-desk/departures/for/${option}/`;
  const params = {dateFrom, dateTo};

  return get(url, params);
};

export const exportDeparturesCsv = ({
  locationRef,
  option,
  dateFrom,
  dateTo
}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/front-desk/departures/for/${option}/export-csv/`;
  const params = {dateFrom, dateTo};

  return get(url, params);
};

export const exportDeparturesCsvInBackground = ({
  locationRef,
  option,
  dateFrom,
  dateTo
}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/front-desk/departures/for/${option}/export-csv/in-background/`;
  const params = {dateFrom, dateTo};

  return get(url, params);
};

export const fetchCheckedOutTodayDepartures = ({locationRef}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/front-desk/departures/checked-out-today/`;

  return get(url);
};

export const fetchMemberCheckInInfo = ({locationRef, bookingId}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/front-desk/booking/${bookingId}/members/check-in/`;

  return get(url);
};

export const fetchMemberCheckOutInfo = ({locationRef, bookingId}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/front-desk/booking/${bookingId}/members/check-out/`;

  return get(url);
};

export const roomInspectionPass = ({locationRef, bookingId, allocationId}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/front-desk/booking/${bookingId}/room-inspection/pass/`;

  let payload = {};

  if (allocationId) {
    payload['allocation'] = allocationId;
  }

  return post(url, payload);
};

export const roomInspectionRemove = ({
  locationRef,
  bookingId,
  allocationId
}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/front-desk/booking/${bookingId}/room-inspection/remove/`;

  let payload = {};

  if (allocationId) {
    payload['allocation'] = allocationId;
  }

  return post(url, payload);
};

export const fetchRoomMoves = ({locationRef, option, dateFrom, dateTo}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/front-desk/room-moves/for/${option}/`;

  const params = {dateFrom, dateTo};

  return get(url, params);
};

export const fetchCompletedRoomMoves = ({locationRef}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/front-desk/room-moves/completed-today/`;

  return get(url);
};

export const exportRoomMovesAndRenewalsCsv = ({
  locationRef,
  option,
  dateFrom,
  dateTo,
  exportRoomMoves,
  exportRenewals
}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/front-desk/room-moves-and-renewals/for/${option}/export-csv/`;

  return get(url, {dateFrom, dateTo, exportRoomMoves, exportRenewals});
};

export const exportRoomMovesAndRenewalsCsvInBackground = ({
  locationRef,
  option,
  dateFrom,
  dateTo,
  exportRoomMoves,
  exportRenewals
}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/front-desk/room-moves-and-renewals/for/${option}/export-csv/in-background/`;

  return get(url, {dateFrom, dateTo, exportRoomMoves, exportRenewals});
};

export const completeRoomMove = ({locationRef, roomMoveId}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/front-desk/room-moves/complete/`;

  const data = {roomMove: roomMoveId};

  return post(url, data);
};

export const undoCompleteRoomMove = ({locationRef, roomMoveId}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/front-desk/room-moves/undo-complete/`;

  const data = {roomMove: roomMoveId};

  return post(url, data);
};

export const fetchPendingRenewals = ({
  locationRef,
  option,
  dateFrom,
  dateTo
}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/front-desk/renewals/pending/for/${option}/`;

  return get(url, {dateFrom, dateTo});
};

export const fetchCompletedRenewals = ({locationRef, option}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/front-desk/renewals/completed/for/${option}/`;

  return get(url);
};

export const renewBooking = ({locationRef, oldBooking, newBooking}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/front-desk/renewals/create/`;

  const data = {oldBooking, newBooking};

  return post(url, data);
};

export const undoRenewBooking = ({locationRef, oldBooking, newBooking}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/front-desk/renewals/undo-create/`;

  const data = {oldBooking, newBooking};

  return post(url, data);
};

export const fetchRoomMove = ({locationRef, roomMoveId}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/front-desk/room-moves/${roomMoveId}/`;

  return get(url);
};

export const giveAccessToRoom = ({locationRef, roomMoveId}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/front-desk/room-moves/${roomMoveId}/give-access/`;

  const data = {locationRef, roomMoveId};
  return post(url, data);
};

export const undoGiveAccessToRoom = ({locationRef, roomMoveId}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/front-desk/room-moves/${roomMoveId}/undo-give-access/`;

  const data = {locationRef, roomMoveId};
  return post(url, data);
};

export const vacateRoom = ({locationRef, roomMoveId}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/front-desk/room-moves/${roomMoveId}/vacate-room/`;

  const data = {locationRef, roomMoveId};
  return post(url, data);
};

export const undoVacateRoom = ({locationRef, roomMoveId}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/front-desk/room-moves/${roomMoveId}/undo-vacate-room/`;

  const data = {locationRef, roomMoveId};
  return post(url, data);
};

export const exportFrontDesk = ({locationRef, option, dateFrom, dateTo}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/front-desk/excel-export/`;

  const data = {
    option,
    dateFrom,
    dateTo
  };

  return requestBlob(url, data);
};

export const fetchPaymentSummary = ({locationRef, bookingId}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/front-desk/booking/${bookingId}/payment-summary/`;

  return get(url);
};

export const fetchRenewBookingInfo = ({locationRef, bookingId}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/front-desk/renewals/renew-info-for-booking/${bookingId}/`;

  return get(url);
};
